export default __webpack_public_path__ + "static/media/esri-network.7be40d57.svg";